<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('starStatistics2_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('starStatistics2_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      highlight-hover-row
      :loading="loading"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="托运人名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="托运人电话"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="avgShipBasicGrade"
        title="评价"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="total"
        title="评价条数"
        min-width="100"
        sortable
      />
      <vxe-table-column title="操作" min-width="50" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('starStatistics2_detail_button')"
            class="item"
            effect="dark"
            content="评价详情"
            placement="top"
          >
            <vxe-button type="text" @click="Shipperlist(scope.row.userCode)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="托运人评价详情"
      width="1300"
      height="80%"
      resize
    >
      <detailslist ref="ShipperlRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { shipmentReport } from "@/api/CustomerService";
import detailslist from "./components/details.vue";
export default {
  components: {
    detailslist
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/orderComment/exportShipmentReportList", //导出接口
        name: "托运人评价"
      },
      tuteship: false,
      loading: false,
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortType: "",
        sortField: "",
        total: 0
      }
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        shipmentReport(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 评价详情方法
    Shipperlist(c) {
      this.$refs.ShipperlRef.getInfo(c);
      this.tuteship = true;
    }
  }
};
</script>
